// Configuration de l'environnement pour le frontend
// ⚠️ SÉCURITÉ: Ne jamais mettre de vraies clés ici !
export const ENV_CONFIG = {
  // Configuration Stripe - Utiliser des variables d'environnement
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
  
  // URL de l'API backend
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  
  // Configuration de l'environnement
  ENVIRONMENT: process.env.NODE_ENV || 'development',
  
  // Configuration de debug
  DEBUG: process.env.REACT_APP_DEBUG === 'true' || false
};

// Fonction pour obtenir la configuration
export const getEnvConfig = () => {
  const config = {
    stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ENV_CONFIG.STRIPE_PUBLISHABLE_KEY,
    apiUrl: process.env.REACT_APP_API_URL || ENV_CONFIG.API_URL,
    environment: process.env.REACT_APP_ENVIRONMENT || ENV_CONFIG.ENVIRONMENT,
    debug: process.env.REACT_APP_DEBUG === 'true' || ENV_CONFIG.DEBUG
  };

  // Vérifications de sécurité en mode développement
  if (config.debug && process.env.NODE_ENV === 'development') {
    console.log('🔒 Vérification de sécurité de la configuration...');
    
    // Vérifier que la clé Stripe est configurée
    if (!config.stripePublishableKey) {
      console.warn('⚠️ Clé Stripe non configurée - Créez un fichier .env.local');
    } else if (!config.stripePublishableKey.startsWith('pk_')) {
      console.error('❌ Format de clé Stripe invalide (doit commencer par pk_)');
    } else {
      console.log('✅ Configuration Stripe valide');
    }
  }

  return config;
};
